// ✅ US Market Developer Tools - Thin Wrapper (DRY principle)
import DeveloperToolsPage from '../../sub/developer-tools';
import SEOHead from '../../../components/SEOHead';

export default function USDeveloperTools() {
  return (
    <>
      <SEOHead
        title='Developer Tools | LBVisible'
        description='Professional development tools and technologies we use to build your website.'
        keywords='developer tools, web development tools, Next.js, React'
        canonicalUrl='/us/sub/developer-tools'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/developer-tools' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/developer-tools' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/kurimo-irankiai' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/developer-tools' },
        ]}
      />

      <DeveloperToolsPage />
    </>
  );
}
